import { render, staticRenderFns } from "./RelativeRelationDelete.vue?vue&type=template&id=6ea4de90&scoped=true&"
import script from "./RelativeRelationDelete.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4de90",
  null
  
)

export default component.exports